if (!customElements.get('media-pagination')) {
  class MediaPagination extends HTMLElement {
    connectedCallback() {
      const containerSelector = this.dataset.scrollContainer;

      this.container = containerSelector
        ? this.querySelector(containerSelector)
        : this.firstElementChild;

      this.slides = Array.from(this.container.children);
      this.pagination = this.querySelector('.media-pagination__pagination');
      this.anchorSelector = this.dataset.paginationAnchor || null;
      this.activeSlide = null;

      if (this.slides.length < 2) {
        if (this.pagination) this.pagination.hidden = true;
        return;
      }

      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        { root: this.container, threshold: 0.5 }
      );

      this.slides.forEach((slide) => this.observer.observe(slide));

      if (this.anchorSelector) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.activeSlide) this.positionPagination(this.activeSlide);
        });
        this.resizeObserver.observe(this.container);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const index = this.slides.indexOf(entry.target);
        this.pagination.textContent = `${index + 1}/${this.slides.length}`;
        this.activeSlide = entry.target;

        if (this.anchorSelector) {
          this.positionPagination(entry.target);
        }

        this.pagination.hidden = false;


        Array.from(this.pagination.classList)
          .filter((c) => c.startsWith('color-scheme'))
          .forEach((c) => this.pagination.classList.remove(c));
        
        const colorClass = Array.from(entry.target.classList).find((c) =>
          c.startsWith('color-scheme')
        );
        if (colorClass) {
          this.pagination.classList.add(colorClass);
        }
      });
    }

    positionPagination(slide) {
      const anchor = slide.querySelector(this.anchorSelector);
      if (!anchor) return;

      const anchorRect = anchor.getBoundingClientRect();
      const wrapperRect = this.getBoundingClientRect();
      const marginBottom = parseFloat(getComputedStyle(anchor).marginBottom);

      this.pagination.style.top = `${anchorRect.bottom - wrapperRect.top + marginBottom}px`;
      this.pagination.style.bottom = 'auto';
    }
  }

  customElements.define('media-pagination', MediaPagination);
}
